<div class="my-5 flex items-start justify-between">
  <div class="flex space-x-4">
    <aux-card
      topText="Patient Visits LTD"
      [middleText]="totalPatientVisitsLTD() | money"
      className="min-w-[230px]"
    />

    @if (isPlannedVisitsEnabled()) {
      <aux-card
        [middleText]="plannedThroughCurrentMonth() | money"
        className=" min-w-[230px]"
        [bottomTemplate]="showPlannedVisits"
        [ngClass]="{ 'bg-aux-green-2': showPlannedVisitsControl.value }"
      >
        <div topText class="flex items-center justify-between">
          <div class="text-sm text-aux-gray-dark-100">
            {{ 'Planned through ' + (currentOpenMonth$ | async | date: 'MMMM') }}
          </div>
          <aux-icon name="AuxLogo" />
        </div>
      </aux-card>
    }

    <ng-template #showPlannedVisits>
      @let disabledReasonToShowTooltip =
        showPannedEOTControl.value
          ? 'Cannot unselect if Show planned visits through EOT is selected'
          : '';

      <aux-checkbox
        class="mr-3"
        [formControl]="showPlannedVisitsControl"
        [class.selected-card]="showPlannedVisitsControl.value"
        [id]="'showPlannedVisitsCheckbox'"
        [disabled]="!!showPannedEOTControl.value"
        [auxTooltip]="disabledReasonToShowTooltip"
      >
        <div class="text-sm">Show planned visits</div>
      </aux-checkbox>
    </ng-template>

    <aux-card
      [middleText]="plannedThroughEOT() | money"
      className=" min-w-[230px]"
      [bottomTemplate]="showPannedEOT"
      [class.bg-aux-blue-arctic]="showPannedEOTControl.value"
    >
      <div topText class="flex items-center justify-between">
        <div class="text-sm text-aux-gray-dark-100">Planned through EOT</div>
        <aux-icon name="AuxLogo" />
      </div>
    </aux-card>

    <ng-template #showPannedEOT>
      <aux-checkbox
        class="mr-3"
        [formControl]="showPannedEOTControl"
        [id]="'showPannedEOTCheckbox'"
      >
        <div class="text-sm">Show planned visits through EOT</div>
      </aux-checkbox>
    </ng-template>
  </div>

  <aux-export-excel-button
    classList="ml-1"
    [clickFN]="onExport.bind(this)"
    [spinnerSize]="7"
    pendoTag="patient-tracker-excel-export-button"
  />
</div>

@if ((isHandlingUpload$ | async) === false && (isLoadingData$ | async) === false) {
  @if (!showGrid()) {
    <ng-container>
      <div class="mt-28 flex flex-col items-center justify-center space-y-5 text-aux-gray-dark">
        <aux-icon name="FileDescription" />
        <div class="text-xl font-bold">No Patient Data to Review</div>
      </div>
    </ng-container>
  }

  @if (showGrid()) {
    <ng-container>
      <form
        [formGroup]="gridFiltersFormGroup"
        class="rounded-xl border border-[#E5E5E5] bg-[#FDFDFE] px-2 py-4"
      >
        <div class="mb-4 flex items-center justify-between space-x-8">
          <div class="flex space-x-8">
            <div class="flex items-center">
              <div class="mr-2 text-xs">Site:</div>
              <aux-site-select-dropdown
                class="w-48 2xl:w-72"
                formControlName="siteIds"
                label=" "
                placeholder="Please select site(s)"
              />
            </div>

            <div class="flex items-center">
              <div class="mr-2 text-xs">Protocol Version:</div>
              <ng-select
                class="w-48 2xl:w-72"
                placeholder="Select version"
                [searchable]="true"
                bindValue="value"
                [formControl]="protocolVersionControl"
                [items]="protocolVersionOptions$ | async"
              />
            </div>

            <div class="flex items-center">
              <div class="mr-2 text-xs">Patient Group:</div>
              <ng-select
                class="w-48 2xl:w-72"
                placeholder="Select group"
                [searchable]="true"
                bindValue="value"
                formControlName="patientGroupId"
                [items]="patientGroupOptions$ | async"
              ></ng-select>
            </div>

            <div class="flex items-center space-x-2 text-sm">
              <div>Dates</div>
              <aux-toggle
                [value]="isDisplayCosts"
                (change)="display$.next($event ? 'costs' : 'dates')"
              />
              <div>Costs</div>
            </div>

            <div class="flex items-center text-sm">
              <aux-toggle-currency
                [value]="isContractedCurrency"
                (nameSelectedCurrency)="selectedVisibleCurrency$.next($event)"
              />
            </div>
          </div>
        </div>
      </form>

      <aux-pagination-grid
        [gridOptions]="(gridOptions$ | async)!"
        [dataSource]="datasource"
        [filterForm]="gridFiltersFormGroup"
        [serverSideFilters]="serverSideFilters"
        [filterValues$]="filterValues$"
        [sortModel$]="sortModel$"
        [idTable]="'patientTrackerTable'"
        [paginationKey]="paginationKey"
        (paginationChange)="onPaginationChange()"
        (gridReady)="onGridReady($event)"
      />
      <a class="btn--hyperlink mb-16 inline-block" [routerLink]="[protocolEntryLink]">
        View Schedule of Assessments
      </a>
    </ng-container>
  }
}
